import { api } from "api";
import { useQuery } from "@tanstack/react-query";

/**
 * Client hook to obtain the current Provider Preview for Payment Request.
 * @returns React Query properties.
 */
export function useGetProviderPreviewPaymentRequest() {
    return useQuery({
        queryKey: ["providerPreviewPaymentRequest"],
        queryFn: async (context) => await api.provider.getPreviewPaymentRequest(context.signal),
        staleTime: 4 * 60 * 1000, // 4 minutes
    });
}
